export default {
  module: 'PUBLIC_FORM',
  SAVE_PUBLIC_FORM_CONFIG: {
    url: '/xdap-app/formConfig/update/formShare',
    method: 'post'
  },
  QUERY_PUBLIC_FORM_CONFIG: {
    url: '/xdap-app//formConfig/query/formShareByFormId',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_SHARE_STATUS: {
    url: '/xdap-app/formShare/check/formShare',
    method: 'post',
    disableSuccessMsg: true
  },
  SAVE_SHARE_CONFIG: {
    url: '/xdap-app/formShare/get/shareUrl',
    method: 'post'
  },
  QUERY_SHARE_CONFIG: {
    url: '/xdap-app/formShare/get/shareConfig',
    method: 'post',
    disableSuccessMsg: true
  },
  CHECK_TENANT_USER: {
    url: '/xdap-app/tenant/check/tenantUser',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_SHARE_CONFIG_EDIT: {
    url: '/xdap-app/formShare/get/editShareConfig',
    method: 'get',
    disableSuccessMsg: true
  }
}
